export let personaPhotoEntries: { [blobUrl: string]: boolean } = {};
